import { Card, CardBody, CardProps } from "@chakra-ui/react";
import { ReactNode } from "react";

interface ContentBoxProps extends CardProps {
	children?: ReactNode;
}

const ContentBox = ({ children, ...props }: ContentBoxProps) => {
	return (
		<Card {...props}>
			<CardBody>{children}</CardBody>
		</Card>
	);
};

export default ContentBox;
